import ApiService from './apiService';

export const reportsApi = {
  getWeeklyPayrollReport(params) {
    return ApiService.get(
      `/report/weekly-payroll`,
      params,
      'getWeeklyPayrollReport'
    )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getPayrollData(params) {
    return ApiService.get(`/reports/payroll-raw-data`, params, 'getPayrollData')
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getPtoBalances(params) {
    return ApiService.get(`/reports/pto-balances`, params, 'getPtoBalances')
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getPtoBalancesEmployee(params) {
    return ApiService.get(
      `/reports/pto-balances-employee`,
      params,
      'getPtoBalancesEmployee'
    )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getCallbackReport(params) {
    return ApiService.get(`/report/callback`, params, 'getCallbackReport')
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getPtoReport(params) {
    return ApiService.get(`/report/pto`, params, 'getPtoReport')
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getEmployeeList(params) {
    return ApiService.get(`/report/employee-list`, params, 'getEmployeeList')
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getAbsertCodes(params) {
    return ApiService.get(`/reports/absert-codes`, params, 'getAbsertCodes')
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getOvertimeReportData(params) {
    return ApiService.get(`/report/overtime`, params, 'getOvertimeReport')
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getOvertimeListMasterReportData(params) {
    return ApiService.get(
      `/report/overtime-list-master`,
      params,
      'getOvertimeListMasterReport'
    )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getPayrollReportData(params) {
    return ApiService.get(`/report/payroll`, params, 'getPayrollReport')
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getMunisReportData(params) {
    return ApiService.get(`/report/munis`, params, 'getMunisReportData')
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getSwapShifts(params) {
    return ApiService.get(`/report/swaps`, params, 'getSwapShiftsReportData')
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getAdjustHours(params) {
    return ApiService.get(
      `/report/adjust-hours`,
      params,
      'getAdjustHoursReportData'
    )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getAvailabilityDetail() {
    return ApiService.get(
      `/report/availability-detail`,
      {},
      'getAvailabilityDetailReportData'
    )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getAvailabilitySummary() {
    return ApiService.get(
      `/report/availability-summary`,
      {},
      'getAvailabilitySummaryReportData'
    )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getMiltonReportData(params) {
    return ApiService.get(`/report/custom`, params, 'getMiltonReportData')
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getCharltonReportData(params) {
    return ApiService.get(`/report/holiday`, params, 'getCharltonReportData')
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getWoburnReportData(params) {
    return ApiService.get(
      `/report/custom-payback`,
      params,
      'getWoburnReportData'
    )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
	getAvailableReportsList(params) {
    return ApiService.get(`/report/reports-list`, params, 'getAvailableReports')
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getWoburnPTOReportData(params) {
    return ApiService.get(
      `/report/custom-pto`,
      params,
      'getWoburnPtoReportData'
    )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },

  getWoburnMunisPtoData(params) {
    return ApiService.get(`/report/custom-pto-munis`, params, 'getWoburnMunisPtoData')
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getWoburnReassignmentReportData(params) {
    return ApiService.get(
      `/report/custom-acting`,
      params,
      'getWoburnReassignmentReportData'
    )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getWoburnOvertimeReportData(params) {
    return ApiService.get(
      `/report/custom-ot`,
      params,
      'getWoburnOvertimeReportData'
    )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
    getWoburnMunisOvertimeReportData(params) {
    return ApiService.get(`/report/custom-ot-munis`, params, 'getWoburnMunisOvertimeReportData')
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getPtoOptionsList() {
    return ApiService.get(`/report/options-list`, {}, 'getPtoOptionsList')
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getPayperiod() {
    return ApiService.post(`/report/payperiod`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
};
